angular.module("dateRequest.components", []).component("dateRequest", {
  templateUrl: "ng/components/dateRequest/dateRequest.view.html",
  bindings: {
    datiRichiesta: "=",
    validityPage: "&"
  },
  controllerAs: "dateRequestCtrl",
  controller: function DateRequest($arcService, Contratto) {
    var self = this;

    self.$onInit = function () {
      console.log("dettaglio", self.datiRichiesta);

      self.supportModel = {
        rb1: self.datiRichiesta.riscatto, 
        rb2: self.datiRichiesta.riscattoCliente,
        defaultMode: "AZIENDA",
        switchOptions: ['AZIENDA', 'PERSONA'],
        listaContratti: [],
        contractSelected: self.datiRichiesta.contratti
      };

      self.handleChange('rb1', self.supportModel.rb1);
      self.handleChange('rb2', self.supportModel.rb2);

      self.getListaContratti();
    };

    self.getListaContratti = function () {
      $arcService.getContracts()
          .then(function (response) {
              self.supportModel.listaContratti = response.listContratti;

              if (response && response.listContratti) {
                  response.listContratti.forEach(function (contratto) {
                    if (self.datiRichiesta.contratti.length!==0 && 
                        self.datiRichiesta.contratti[0].numero === contratto.numeroContratto && 
                        self.datiRichiesta.contratti[0].modulo === contratto.numeroModulo ) {
                        self.supportModel.contractSelected = contratto;
                        self.handleChange('contractSelected', self.supportModel.contractSelected);
                    }
                })
              }
          })
    }

    self.handleChange = function (property, value)  {
      switch (property) {
        case 'contractSelected':
          self.contractSelected = Contratto.build();
          self.contractSelected.numero = value.numeroContratto;
          self.contractSelected.modulo = value.numeroModulo;
          self.datiRichiesta.contratti = [];
          self.datiRichiesta.contratti.push(self.contractSelected);
          self.datiRichiesta.prodottoTargato = (value.cluster === 'TARGATO');
          console.log("datiRichiesta: ", self.datiRichiesta);
          break
        case "rb1":
          self.datiRichiesta.riscatto = self.supportModel.rb1;
          break;
        case "rb2":
          self.datiRichiesta.riscattoCliente = self.supportModel.rb2;
          break;
        case "customer":
          if (value && value.riUserF) {
            self.datiRichiesta.azienda = {};
            self.datiRichiesta.persona = value.riUserF;
          }
          if (value && value.riUserG) {
            self.datiRichiesta.persona = {};
            self.datiRichiesta.azienda = value.riUserG;
          break;
        }
      }
      exportValidity();
    }

    var exportValidity = function() {
      //var datiRichiesta = self.datiRichiesta.contratti && self.supportModel.validity

      var control = self.setControl();

      if (control) {
        self.validityPage({
          validity: true
        });
      } else {
        self.validityPage({
          validity: false
        });
      }
    }

    self.setControl = function() {
      var control = false;
      if (self.datiRichiesta.prodottoTargato) {
        if(self.datiRichiesta.riscattoCliente) {
          control = self.datiRichiesta.contratti.length 
              && self.datiRichiesta.riscattoCliente && self.supportModel.validity;
        } else {
          control = self.datiRichiesta.contratti.length && !self.datiRichiesta.riscattoCliente;
        }
      } else {
        control = self.datiRichiesta.contratti.length;
      }
      return control;
    }

    self.exportValidityCustomerDigital = function(validity) {
       self.supportModel.validity = validity;
       exportValidity();
      }
  }
});
